import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Navbar, Nav, Row, Col, Container } from "react-bootstrap";

import PrhBrand from "./PrhBrand";
import LanguageSelect from "./LanguageSelect";
import Icons from "../../scss/prh-icon-sprite.svg";
import { Bulletins } from "../common/Bulletins";
import { I18nContext } from "../../i18n";

const ExpandedNavbar = (props) => {
  const { translate } = useContext(I18nContext);

  return (
    <>
      <Bulletins lang={document.documentElement.lang} />
      <header className="prh-site-header">
        <div className="container prh-site-header__container pt-2">
          <Navbar expand="true" className="navbar navbar-dark navbar-expand-md">
            <Nav style={{ width: "100%" }}>
              <Container
                fluid="true"
                className="pl-3 pr-3"
                style={{ width: "100%" }}
              >
                <Row>
                  <Col md={8} className="pl-0">
                    <PrhBrand pathParams={props.pathParams} />
                  </Col>
                  <Col md={4}>
                    <LanguageSelect pathParams={props.pathParams} />
                  </Col>
                  <Col md={12} className="mt-0 pt-0">
                    <Row style={{ justifyContent: "space-between" }}>
                      <Col
                        xs="auto"
                        className={props.activeLink === "Home" ? "active-link" : "link"}
                      >
                        <Link data-cy="home" to={props.pathParams.buildPath()}>
                          <svg
                            alt={translate("trademark_navigation_home")}
                            className="prh-icon prh-icon--xs stroke-white"
                          >
                            <use xlinkHref={`${Icons}#home`}></use>
                          </svg>
                          <span
                            className={props.activeLink === "Home"
                              ? "active-menu-text ml-1"
                              : "menu-text ml-1"}
                            style={{ fontSize: "1.1rem" }}
                          >
                            {translate("trademark_frontpage")}
                          </span>
                        </Link>
                      </Col>
                      <Col
                        xs="auto"
                        className={props.activeLink === "Search" ? "active-link" : "link"}
                      >
                        <Link data-cy="search" to={props.pathParams.buildPath('search')}>
                          <span
                            className={props.activeLink === "Search"
                              ? "active-menu-text ml-1 mr-1"
                              : "menu-text ml-1 mr-1"}
                            style={{ fontSize: "1.1rem" }}
                          >
                            {translate("trademark.portlet.advanced.search")}
                          </span>
                        </Link>
                      </Col>
                      <Col
                        xs="auto"
                        className={props.activeLink === "TMR" ? "active-link" : "link"}
                      >
                        <Link data-cy="known_tm" to={props.pathParams.buildPath('tmr')}>
                          <span
                            className={props.activeLink === "TMR"
                              ? "active-menu-text ml-1 mr-1"
                              : "menu-text ml-1 mr-1"}
                            style={{ fontSize: "1.1rem" }}
                          >
                            {translate("menu_known_trademarks")}
                          </span>
                        </Link>
                      </Col>
                      <Col xs="auto" className={"link"}>
                        <a
                          data-cy="tabs"
                          href={translate("navbar_tmgazette_extlink")}
                        >
                          <svg
                            className="prh-icon prh-icon--xs stroke-white"
                            aria-labelledby="gazette_link"
                          >
                            <title id="gazette_link">
                              {translate("trademark_external_link")}
                            </title>
                            <use xlinkHref={`${Icons}#external-link`}></use>
                          </svg>
                          <span
                            className="menu-text ml-1"
                            style={{ fontSize: "1.1rem" }}
                          >
                            {translate("menu_tabs")}
                          </span>
                        </a>
                      </Col>
                      <Col xs="auto" className={"link"}>
                        <a
                          data-cy="instructions"
                          href={translate("navbar_searchinstructions_extlink")}
                        >
                          <svg
                            className="prh-icon prh-icon--xs stroke-white"
                            aria-labelledby="instructions_link"
                          >
                            <title id="instructions_link">
                              {translate("trademark_external_link")}
                            </title>
                            <use xlinkHref={`${Icons}#external-link`}></use>
                          </svg>
                          <span
                            className="menu-text ml-1"
                            style={{ fontSize: "1.1rem" }}
                          >
                            {translate("menu_instructions")}
                          </span>
                        </a>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Container>
            </Nav>
          </Navbar>
        </div>
      </header></>
  );
};

export default ExpandedNavbar;
